import log from "loglevel";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Extract course ID from path like /courseware/course/123/content/labs
 * Returns null if not a course path
 */
const extractCourseId = (pathname) => {
    const match = pathname.match(/^\/courseware\/course\/(\d+)/);
    return match ? match[1] : null;
};

const ScrollToTop = () => {
    const location = useLocation();
    const prevPathnameRef = useRef(location.pathname);

    useEffect(() => {
        const prevPathname = prevPathnameRef.current;
        const currentPathname = location.pathname;

        // Update ref for next comparison
        prevPathnameRef.current = currentPathname;

        // Check if navigating within the same course
        const prevCourseId = extractCourseId(prevPathname);
        const currentCourseId = extractCourseId(currentPathname);

        // Skip scroll if staying within the same course (sidebar navigation)
        if (prevCourseId && currentCourseId && prevCourseId === currentCourseId) {
            log.log("Skipping scroll - same course navigation");
            return;
        }

        let timeId = setTimeout(() => {
            log.log("scrolling to top");
            window.scrollTo(0, 0);
        }, 100);
        return () => clearTimeout(timeId)
    }, [location.pathname, location.key]);

    return null;
};

export default ScrollToTop;
